import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DipendentiArticoliDettaglio } from 'src/app/models/dipendenti-articoli-dettaglio';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DettaglioArticoloDipendenteService {
  private http = inject(HttpClient);


  dadUrl = environment.ildatoArticoliDpi + 'api/dettagliarticolodipendente';


  list(): Observable<DipendentiArticoliDettaglio[]> {
    return this.http.get<DipendentiArticoliDettaglio[]>(`${this.dadUrl}`);    
  }

  listByDipendente(idDipendente: number): Observable<DipendentiArticoliDettaglio[]> {
    return this.http.get<DipendentiArticoliDettaglio[]>(`${this.dadUrl}/bydipendente/${idDipendente}`);    
  }

  get(idArticolo: number, idDipendente: number): Observable<DipendentiArticoliDettaglio> {
    return this.http.get<DipendentiArticoliDettaglio>(`${this.dadUrl}/${idArticolo}/${idDipendente}`);    
  }

  insert(values: DipendentiArticoliDettaglio): Observable<DipendentiArticoliDettaglio> {
    return this.http.post<DipendentiArticoliDettaglio>(`${this.dadUrl}`, values);    
  }

  update(idArticolo: number, idDipendente: number, values: DipendentiArticoliDettaglio): Observable<DipendentiArticoliDettaglio> {
    return this.http.put<DipendentiArticoliDettaglio>(`${this.dadUrl}/${idArticolo}/${idDipendente}`, values);    
  }

  remove(idArticolo: number, idDipendente: number): Observable<DipendentiArticoliDettaglio> {
    return this.http.delete<DipendentiArticoliDettaglio>(`${this.dadUrl}/${idArticolo}/${idDipendente}`);    
  }
}
